import bell from "../assets/images/bell-icon.png"
import "../styles/navbar.css";
import { useAuth } from "../context/AuthContext";
import { useEffect, useRef, useState } from "react";
import { API_CONFIG } from "../config/api";
import { generateURN, generateAuthToken } from "./hmac";




const Alerts = () => {  

  const { profileUser } = useAuth();
  const [alerts,setAlerts]=useState([]);
  const [showAlerts,setShowAlerts]=useState(true);
  const dropdownRef = useRef();


    useEffect(() => {

        const fetchAlertsAPI = async () => {
        try {
            const { host,  basic ,fetchAlerts} = API_CONFIG;
            const urn = generateURN();
            const authToken = generateAuthToken(urn);
            const name=profileUser.userName;

            const res = await fetch(
              `https://${host}${fetchAlerts.path}?user=${name}`,
            {
                method: fetchAlerts.method,
                headers: {
                "Content-Type": "application/json",
                Authorization: `Basic ${basic.BASIC_AUTH_CWUSER}`,
                urn,
                authToken,
                },
                credentials: "include",
            }
            );

            const data = await res.json();
            const Alertdata = data?.apiResponseData?.responseData?.alerts;
            setAlerts(Alertdata);
        } catch (err) {
            console.error("Alert fetch failed", err);
        }
        };

        fetchAlertsAPI();
    }, [profileUser]);




    useEffect(() => {
    const handleClickOutside = (event) => {
        if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowAlerts(false);
        }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);



  return (
    <>
   
     <img
     ref={dropdownRef}
        src={bell}
        alt="Notifications"
        className="bell-icon"
        onClick={()=>(setShowAlerts(true))}
      />

      {showAlerts && profileUser &&  (
        <div className="alerts-dropdown">
            <div className="alerts-header">Notifications</div>

            {alerts.length === 0 ? (
            <div className="alerts-empty">No new notifications</div>
            ) : (
            <div className="alerts-list">
                {alerts.map((alert) => (
                <div key={alert._id} className="alert-item">
                    <div className="alert-heading">{alert.heading}</div>
                    <div className="alert-message">{alert.message}</div>
                </div>
                ))}
            </div>
            )}
        </div>
        )}

      
    </>
  );
};

export default Alerts;